import createUrlBuilder from 'utilities/url.builder.utils';
import {
  getRequest,
  postRequest,
  deleteRequest,
  patchRequest
} from 'utilities/service.utils';
import AppService from './app.service.context';
import { Params } from 'types';

export const getAnnouncements = async (params: any) => {
  const anonymous: boolean = params.anonymous;
  const urlBuilder = createUrlBuilder(
    `/system/notices${anonymous ? '/anonymous' : ''}?fields=*`
  ).toString();

  return await getRequest(AppService, urlBuilder, params);
};

export const hideAnnouncement = async (id: number) => {
  const urlBuilder = createUrlBuilder(`/system/notices/${id}/hide`).toString();

  return await postRequest(AppService, urlBuilder);
};

export const unhideAnnouncement = async (id: number) => {
  const urlBuilder = createUrlBuilder(
    `/system/notices/${id}/unhide`
  ).toString();

  return await postRequest(AppService, urlBuilder);
};

export const deleteAnnouncement = async (id: number) => {
  const urlBuilder = createUrlBuilder(`/system/notices/${id}`).toString();

  return await deleteRequest(AppService, urlBuilder);
};

export const updateAnnouncement = async (payload: any) => {
  const id = payload.id;
  const params = payload.params;
  const urlBuilder = createUrlBuilder(`/system/notices/${id}`).toString();

  return await patchRequest(AppService, urlBuilder, params);
};

export const addAnnouncement = async (payload: any) => {
  const params = payload;
  const urlBuilder = createUrlBuilder(`/system/notices`).toString();

  return await postRequest(AppService, urlBuilder, params);
};

export const getListAnnouncements = async (queryParams: Params) => {
  const {
    fields = '*',
    offset = 0,
    limit = 20,
    orderBy = '-endAt',
    filter = '',
    include
  } = queryParams;

  const params = {
    returnActiveOnly: false,
    fields,
    offset,
    limit,
    order: orderBy,
    filter,
    include
  };
  const urlBuilder = createUrlBuilder(`/system/notices`).toString();
  return await getRequest(AppService, urlBuilder, params);
};
